import { AbstractControl, ValidationErrors } from '@angular/forms';

export function companyIdentificationValidator(control: AbstractControl): ValidationErrors | null {
	if (control.value) {
		const valid = /^[0-9]{10}$/.test(control.value);

		if (!valid) {
			return {
				format: true,
			};
		}
	}

	return null;
}
